<template>
  <div>
    <ylNewsDetailsMobile
      v-if="isMobileScreen"
      v-bind="$attrs"
       />
    <ylNewsDetailsPC
      v-else
      v-bind="$attrs"
       />
  </div>
</template>
<script>
export default {
  name: "ylNewsDetails",
  components: {
    ylNewsDetailsMobile: () => import("./components/mobile.vue"),
    ylNewsDetailsPC: () => import("./components/pc.vue"),
  },
  data() {
    return {};
  },
  computed: {
    screenWidth() {
      return this.$store.getters.screenWidth;
    },
    screenHeight() {
      return this.$store.getters.screenHeight;
    },
    isMobileScreen() {
      return this.$store.getters.isMobileScreen;
    },
  },
  created() {},
  methods: {},
};
</script>